<template>
  <v-container fluid>
    <v-dialog v-model="visible" max-width="465px" @input="backToParent($event)">
      <v-card class="px-6 py-6">
        <v-card-title primary-title class="downloadTitle text-center pt-8">
          {{ $t('devices.download.title') }}
        </v-card-title>
        <v-card-text class="text-center">
          {{ $t('devices.download.subheader') }}
        </v-card-text>

        <v-tabs
          v-model="tab" class="pt-6"
          background-color="transparent"
          color="black"
          centered
          hide-slider
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab id="android" href="#android">
            {{ $t('devices.download.android') }}
          </v-tab>

          <v-tab id="apple" href="#apple">
            {{ $t('devices.download.iphone') }}
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab" class="pt-6">
          <v-tab-item :key="1" value="android" :transition="false">
            <v-card flat>
              <v-card-text class="text-center">
                <qrcode-vue :value="qrCodeAndroidValue" :size="qrCodeSize" :level="qrCodeLevel"></qrcode-vue>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :key="2" value="apple" :transition="false">
            <v-card flat>
              <v-card-text class="text-center">
                <qrcode-vue :value="qrCodeIphoneValue" :size="qrCodeSize" :level="qrCodeLevel"></qrcode-vue>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>

        <v-card-actions class="pt-14">
          <v-btn id="done" color="primary" class="v-btn-done text-center" block @click="back">
            {{ $t('main.done') }}
          </v-btn>
        </v-card-actions>

        <v-spacer />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import QrcodeVue from 'qrcode.vue'

export default {
  name: 'AddDevice',

  components: {
    QrcodeVue
  },

  data() {
    return {
      visible: true,
      deviceFormValid: false,
      minCharacters: 4,
      maxCharacters: 255,
      tab: 'android',
      qrCodeAndroidValue: this.$store.state.remoteConfig.sicAndroidLink,
      qrCodeIphoneValue: this.$store.state.remoteConfig.sicIphoneLink,
      qrCodeHostValue: '{"url": "' + this.$store.state.remoteConfig.rsspApiUrl + '"}',
      qrCodeSize: 250,
      qrCodeLevel: 'M',
      rules: {
        required: (v) => !!v || !isNaN(parseFloat(v)) || this.$t('validation.form.requiredField'),
        minMax: (v) => ((v && v.length >= this.minCharacters) && (v && v.length <= this.maxCharacters)) || this.$t('validation.form.mustBeBetween', { min: this.minCharacters, max: this.maxCharacters })
      }
    }
  },

  methods: {

    backToParent(e) {
      if (!e) {
        this.$router.go(-1)
      }
    },

    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style>
.downloadTitle {
  word-break: break-word;
  font-weight: 600 !important;
  font-size: 26px !important;
  line-height: 31px;
}
.v-btn-back {
  /*width: 187px;*/
  min-width: 187px !important;
}
.v-btn-done {
  /*width: 187px;*/
  min-width: 187px !important;
}
.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active),
.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-icon,
.theme--dark.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active) > .v-btn,
.theme--dark.v-tabs > .v-tabs-bar .v-tab--disabled {
  color: #a3a3a3 !important;
}
</style>
